<template>
  <div class="userRole-page">
    <div class="userRoleheader-wrap">
      <h3 class="userRoleslelect-title">{{ $t('user.selectRole') }}</h3>
      <div class="left-part">
        <!-- <button class="users-role" v-for="(item, index) in rolesData" :key="index" @click="selectTag(item.id)" :class="{'active-button-style': item.id===roleId}">                    
                    {{item.name}}
                </button> -->
        <el-tag
          class="users-role"
          :class="{ 'active-button-style': item._id === currentRoleItem._id }"
          v-for="(item, index) in rolesData"
          @click="selectTag(item)"
          @close="closeTag(item._id)"
          :key="item.id"
          size="medium"
          closable
        >
          {{ item.userPowerRole }}：{{ item.name }}
        </el-tag>
      </div>
      <button class="global-button-style" @click="createPowerRoles">
        <img src="@/assets/img/cmb_btn_add.png" alt="add" />{{
          $t('user.addRole')
        }}
      </button>
    </div>

    <div class="app-table-container">
      <el-row :gutter="20">
        <el-col :span="12">
          <DataTable
            tableId="table-first"
            :tableProps="PowerRolesProps"
            :tableData="PowerRolesData"
            :tableTitle="$t('user.selectedPermission')"
            @tableHandle="selectedHandle"
          >
            <!-- <pagination
                        layout="prev, pager, next"
                        :pageSize='selectedParams.limit'
                        :total="selectedTotal"
                        @pageNum="selectPageNum"                            
                        /> -->
          </DataTable>
        </el-col>

        <el-col :span="12">
          <DataTable
            tableId="table-second"
            :tableProps="PowerProps"
            :tableData="PowerData"
            :tableTitle="$t('user.optionalPermission')"
            @tableHandle="selectableHandle"
          >
            <!-- <pagination
                        layout="prev, pager, next"
                        :pageSize='selectableParams.limit'
                        :total="selectableTotal"
                        @pageNum="selectablePageNum"
                        /> -->
          </DataTable>
          <div
            class="userRole-createRole global-button-style"
            @click="createPower()"
          >
            <i class="el-icon-plus"></i>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="footer-btn-wrap">
      <button class="global-button-style" @click="saveHandle">
        {{ $t("commonMsg.save") }}
      </button>
    </div> -->
    <AddRole
      v-if="roleDialog"
      :dialogVisible="roleDialog"
      :editData="ruleForm"
      :title="ruleTitle"
      @confirm="addRoleConfirm"
      @close="roleDialog = false"
    />
    <AddPower
      v-if="powerDialog"
      :dialogVisible="powerDialog"
      :editData="ruleForm"
      :title="ruleTitle"
      @confirm="addPowerConfirm"
      @close="powerDialog = false"
    />

    <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
  </div>
</template>

<script>
import DataTable from '@/components/dataTable'
import AddRole from './components/createRole'
import AddPower from './components/createPower'
import pagination from '@/components/pagination'
import DelPopup from '@/components/delPopup'
import { mapGetters } from 'vuex'

export default {
  name: 'Roles',
  components: {
    DataTable,
    AddRole,
    AddPower,
    pagination,
    DelPopup
  },
  computed: {
    ...mapGetters(['addPopup', 'delPopup']),
    PowerRolesProps() {
      let PowerRolesProps = [
        {
          prop: 'name',
          label: '标题'
        },
        {
          prop: 'ordinal',
          label: '权值'
        },
        {
          prop: 'userRole-tag',
          label: '权限名称'
        },
        {
          prop: 'userRole-engine',
          label: '引擎'
        },
        {
          prop: 'target',
          label: '标识'
        },
        {
          prop: 'allTimes',
          label: '总使用次数/字数'
        },
        {
          prop: 'dayTimes',
          label: '当天可用'
        },
        {
          prop: 'handle',
          label: this.$t('commonMsg.handle'),
          width: 120,
          btn: [this.$t('commonMsg.edit'), this.$t('commonMsg.del')]
        }
      ]
      return PowerRolesProps
    },
    PowerProps() {
      let PowerProps = [
        {
          prop: 'name',
          label: '标题'
        },
        {
          prop: 'ordinal',
          label: '权值'
        },
        {
          prop: 'userRole-tag',
          label: '权限名称'
        },
        {
          prop: 'userRole-engine',
          label: '引擎'
        },
        {
          prop: 'target',
          label: '标识'
        },
        {
          prop: 'allTimes',
          label: '总使用次数/字数/时长(秒)'
        },
        {
          prop: 'dayTimes',
          label: '当天可用'
        },
        {
          prop: 'handle',
          label: this.$t('commonMsg.handle'),
          width: 160,
          btn: [
            this.$t('commonMsg.add'),
            this.$t('commonMsg.edit'),
            this.$t('commonMsg.del')
          ]
        }
      ]
      return PowerProps
    }
  },
  data() {
    return {
      hasSelected: false,
      roleDialog: false,
      powerDialog: false,
      rolesData: [],
      currentRoleItem: null,
      tagId: '',
      rules: {},
      ruleForm: {},
      ruleTitle: '',
      PowerRolesData: [],
      PowerData: [],
      selectedTotal: 0,
      selectableTotal: 0,
      selectedParams: { limit: 20, offset: 0 },
      selectableParams: { limit: 20, offset: 0 }
    }
  },
  methods: {
    addRoleConfirm(data) {
      this.addPowerRoles(data)
    },
    addPowerConfirm(data) {
      this.ruleTitle === '创建权限' ? this.addPower(data) : this.editPower(data)
    },

    async getPowerRolesList() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.$http.getPowerRolesList()
          this.rolesData = res.data.results
          this.getCurrentRoleItem()
          resolve('ok')
        } catch (error) {}
      })
    },

    getCurrentRoleItem() {
      if (this.currentRoleItem) {
        this.currentRoleItem = this.rolesData.find(
          (item) => item._id === this.currentRoleItem._id
        )
      } else {
        this.currentRoleItem = this.rolesData[0]
      }
      this.PowerRolesData = Object.assign([], this.currentRoleItem.power)
    },

    async getPowersList() {
      try {
        let res = await this.$http.getPowersList({ limit: 100 })
        let ids = this.PowerRolesData.map((item) => item._id)
        this.PowerData = res.data.results.filter(
          (item) => !ids.includes(item._id)
        )
        this.selectableTotal = res.data.count
      } catch (error) {}
    },

    createPower(item = null) {
      if (item) {
        this.ruleForm = Object.assign({}, item)
        this.ruleTitle = '编辑权限'
      } else {
        this.ruleForm = {}
        this.ruleTitle = '创建权限'
      }
      this.powerDialog = true
    },

    async addPower(data) {
      try {
        await this.$http.createPowers(data)
        this.getPowersList()
        this.powerDialog = false
        this.elMsg(this.$t('alertMsg.addSuccess'), 'success')
      } catch (error) {
        this.elMsg(error.response.data.message, 'error')
      }
    },

    async editPower(data) {
      try {
        await this.$http.editPowers(data._id, data)
        this.getPowersList()
        this.powerDialog = false
        this.elMsg(this.$t('alertMsg.editSuccess'), 'success')
      } catch (error) {
        this.elMsg(error.response.data.message, 'error')
      }

      if (this.hasSelected) {
        // 编辑已选项
        this.getPowerRolesList()
      }
    },

    getRoleModules(id) {
      return new Promise((resolve, reject) => {
        this.roleId = id
        this.$http
          .getRoleModules(id)
          .then((res) => {
            this.selectedTotal = res.data.count
            this.PowerRolesData = res.data.rows
            resolve()
          })
          .catch(() => {})
      })
    },

    createPowerRoles() {
      this.ruleTitle = this.$t('user.addRole')
      this.roleDialog = true
    },

    async addPowerRoles(data) {
      try {
        data.level = data.userPowerRole === 'unLogin' ? 0 : 1
        await this.$http.addPowerRoles(data)
        this.getPowerRolesList()
        this.roleDialog = false
        this.elMsg(this.$t('alertMsg.addSuccess'), 'success')
      } catch (error) {
        this.elMsg(this.$t('alertMsg.addFailure'), 'error')
      }
    },

    async editPowerRoles() {
      await this.$http.editPowerRoles(
        this.currentRoleItem._id,
        this.currentRoleItem
      )
      this.getPowerRolesList()
      this.elMsg(this.$t('alertMsg.editSuccess'), 'success')
    },

    async selectTag(item) {
      this.currentRoleItem = item
      this.getCurrentRoleItem()
      this.getPowersList()
    },

    closeTag(id) {
      this.tagId = id
      this.$store.commit('windowHandle', 'delPopup')
    },

    async deleteHandle() {
      try {
        await this.$http.delPowerRoles(this.tagId)
        this.elMsg(this.$t('alertMsg.delSuccess'), 'success')
        this.getPowerRolesList()
      } catch (error) {
        this.elMsg(this.$t('alertMsg.delFailure'), 'error')
      }
    },

    selectedHandle({ data, type }) {
      // 操作已选项
      this.hasSelected = true
      if (type === this.$t('commonMsg.del')) {
        this.PowerRolesData.splice(data.$index, 1)
        this.PowerData = [...this.PowerData, data.row]
        this.currentRoleItem.power.splice(data.$index, 1)
        this.editPowerRoles()
      } else if (type === this.$t('commonMsg.edit')) {
        this.createPower(data.row)
      }
    },

    async selectableHandle({ data, type }) {
      // 操作未选项
      this.hasSelected = false
      if (type === this.$t('commonMsg.add')) {
        this.PowerData.splice(data.$index, 1)
        this.PowerRolesData = [...this.PowerRolesData, data.row]

        this.currentRoleItem.power = this.PowerRolesData
        this.editPowerRoles()
      } else if (type === this.$t('commonMsg.edit')) {
        this.createPower(data.row)
      } else {
        this.delPowers(data.row._id)
      }
    },

    async delPowers(id) {
      await this.$http.delPowers(id)
      this.elMsg(this.$t('alertMsg.delSuccess'), 'success')
      this.getPowersList()
    },

    // saveHandle() {
    //   let tempArr = this.PowerRolesData.map(item => item.id);
    //   this.$http
    //     .updateRoleModules({ module_ids: tempArr, role_id: this.roleId })
    //     .then(res => {
    //       this.getRoleModules(this.roleId);
    //       this.elMsg(this.$t("alertMsg.modifySuccess"), "success");
    //     })
    //     .catch(error => {
    //       this.elMsg(this.$t("alertMsg.modifyFailure"), "error");
    //     });
    // },

    //  分页
    selectPageNum(offset) {
      this.selectedParams.offset = offset
      this.getRoleModules(this.roleId)
    },
    //  分页
    selectablePageNum(offset) {
      this.selectableParams.offset = offset
      this.getPowersList()
    }
  },
  async mounted() {
    await this.getPowerRolesList()
    this.getPowersList()
  }
}
</script>

<style lang="scss">
.userRole-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .userRoleheader-wrap {
    min-height: 66px;
    padding: 5px 44px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .userRoleslelect-title {
      width: 90px;
      margin-right: 10px;
    }
    .left-part {
      /* display: flex; */
      flex: 1;
      > span {
        font-size: 16px;
        margin-bottom: 5px;
        margin-top: 5px;
      }
      .users-role {
        background: #fff;
        /* padding: 0; */
        /* width: 92px;
                    height: 32px;
                    line-height: 32px; */
        text-align: center;
        /* margin-left:16px; */
        font-size: $globalBtnFontSize;
        border-radius: 4px;
        border: 1px solid $globalBorderColor;
        color: $globalFontSizeColor;
        outline: none;
        cursor: pointer;
        transition: all 0.3s;
        > .el-icon-close {
          font-size: 15px;
        }
        &:hover {
          background: $globalLessBGColor;
          border-color: $globalLessBGColor;
          color: #fff;
          > .el-tag__close {
            color: #fff;
            &:hover {
              background: #fff;
              color: $globalFontSizeColor;
            }
          }
        }
      }
      .active-button-style {
        color: #fff;
        border-color: $globalBGColor;
        background: $globalBGColor;
        > .el-icon-close {
          font-size: 15px;
        }
        > .el-tag__close {
          color: #fff;
          /* &:hover {
                            background:$globalFontSizeColor;
                        } */
        }
      }
    }
  }
  .app-table-container {
    flex: 1;
    overflow: hidden;
    .userRole-createRole {
      position: absolute;
      right: 30px;
      top: 10px;
    }
  }
  .footer-btn-wrap {
    text-align: center;
    margin-bottom: 20px;
    .global-button-style {
      width: 140px;
    }
  }
}
</style>
